import {
  SET_PROCEDURES,
  SET_PROCEDURES_QUERY_PARAMS,
  SET_PROCEDURES_SET_IS_FETCHING,
} from '../constants/proceduresActionsTypes';

const initialState = {
  list: [],
  params: {
    per_page: 10,
    page: 1,
    sort: 'created_at,desc',
    search: '',
  },
  isFetching: false,
  total: 0,
};

function procedures(state = initialState, action) {
  switch (action.type) {
    case SET_PROCEDURES:
      return {
        ...state,
        list: action.data.procedures,
        total: action.data.total,
      };
    case SET_PROCEDURES_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    case SET_PROCEDURES_SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    default:
      return state;
  }
}

export default procedures;
